module.exports = __webpack_public_path__ + "img/Marvel_wireframe_assets_SkyBackground.1767a6dd.jpg";